<h2 class="headline-5">{{ 'COMMON.POLICYHOLDER' | translate }}</h2>

<dap-lib-icon-radio-button-row
  *ngIf="genderOptions$ | async as genderOptions"
  [error]="validatorService.getErrorMessage(formGroup.get('gender'), validateForm)"
  [options]="genderOptions"
  [formControl]="formGroup.controls.gender"
></dap-lib-icon-radio-button-row>

<dap-lib-form-field
  [error]="validatorService.getErrorMessage(formGroup.get('firstName'), validateForm)"
  inputId="firstName-policyholder"
  label="{{ 'COMMON.FIRST_NAME' | translate }}"
>
  <input
    sscCapitalize
    data-cy="input-first-name-policyholder"
    [formControl]="formGroup.controls.firstName"
    id="firstName-policyholder"
    placeholder="{{ 'COMMON.FIRST_NAME' | translate }}"
    type="text"
  />
</dap-lib-form-field>
<dap-lib-form-field
  [error]="validatorService.getErrorMessage(formGroup.get('lastName'), validateForm)"
  inputId="lastName-policyholder"
  label="{{ 'COMMON.LAST_NAME' | translate }}"
>
  <input
    sscCapitalize
    data-cy="input-last-name-policyholder"
    [formControl]="formGroup.controls.lastName"
    id="lastName-policyholder"
    placeholder="{{ 'COMMON.LAST_NAME' | translate }}"
    type="text"
  />
</dap-lib-form-field>

<dap-lib-date-picker
  *ngIf="datePickerConfig$ | async as datePickerConfig"
  (blurEvent)="hideDateValidation = false"
  inputId="dateOfBirth-policyholder"
  data-cy="input-birthday-policyholder"
  label="{{ 'COMMON.DATE_OF_BIRTH' | translate }}"
  placeHolder="{{ 'COMMON.DATE_OF_BIRTH' | translate }}"
  [formControl]="formGroup.controls.dateOfBirth"
  [language]="datePickerConfig.currentLanguage"
  [minDate]="datePickerConfig.minDate"
  [maxDate]="datePickerConfig.maxDate"
  (focusEvent)="hideDateValidation = true"
  [error]="validatorService.getDateOfBirthErrorMessage(formGroup, !hideDateValidation && validateForm)"
></dap-lib-date-picker>

<div class="contact-data" *ngIf="addressFormGroup">
  <h3 class="headline-5">{{ 'COMMON.CONTACT' | translate }}</h3>
  <dap-lib-form-field
    *ngIf="formGroup.controls.email"
    [error]="validatorService.getErrorMessage(formGroup.controls.email, validateForm)"
    inputId="email-policyholder"
    label="{{ 'COMMON.EMAIL' | translate }}"
  >
    <input
      data-cy="input-email-policyholder"
      [formControl]="formGroup.controls.email"
      id="email-policyholder"
      placeholder="{{ 'COMMON.EMAIL' | translate }}"
      type="email"
    />
  </dap-lib-form-field>
  <dap-lib-form-field
    *ngIf="formGroup.controls.phone"
    [error]="validatorService.getErrorMessage(formGroup.controls.phone, validateForm)"
    inputId="phone-policyholder"
    label="{{ 'COMMON.PHONE_NR' | translate }}"
  >
    <input
      data-cy="input-phone-policyholder"
      [formControl]="formGroup.controls.phone"
      id="phone-policyholder"
      placeholder="{{ 'COMMON.PHONE_NR' | translate }}"
      type="tel"
    />
  </dap-lib-form-field>

  <ssc-personal-address [formGroup]="addressFormGroup" [validateForm]="validateForm"></ssc-personal-address>
</div>
